<template>
	<v-container grid-list-xl>
		<v-layout row wrap>
			<v-flex lg12 class="userInfo">
				<div class="historyBox" v-for="history in globalModalParams.history">
					<table width="100%">
						<tr>
							<td ><strong>NEW STATUS:</strong></td>
							<td>{{ history.statusTo }}</td>
						</tr>
						<tr>
							<td ><strong>PREVIOUS STATUS:</strong></td>
							<td>{{ history.statusFrom }}</td>
						</tr>
						<tr>
							<td ><strong>DATE CHANGED:</strong></td>
							<td>{{ history.date }}</td>
						</tr>
						<tr>
							<td ><strong>CHANGED BY:</strong></td>
							<td>{{ history.fullname }}</td>
						</tr>
						<tr>
							<td ><strong>COMMENTS:</strong></td>
							<td>{{ fncCheckComment(history.comment) }}</td>
						</tr>
					</table>
				</div>
				<p v-if="Object.keys(globalModalParams.history).length === 0">There are no status changes recorded for this entry.</p>
			</v-flex>
			<div class="pl-4 pr-4 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
				</div>
			</div>
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
	  name: 'Settings',
	  data () {
			return {
				objUser: 0
			};
		},
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
            fncCheckComment(comment) {
                if( comment === '' ) {
                    return 'No Comment';
                } else {
                    return comment;
                }
            }
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
